import { useEffect, useMemo, useCallback } from 'react'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import ReactPaginate from 'react-paginate'
import { useMain } from '../../contexts/MainContext'

import api from '../../services/api'

import { Header } from '../../components/Header'
import { ModalAdd } from '../../components/ModalAdd'
import { ModalEdit } from '../../components/ModalEdit'
import { ModalDelete } from '../../components/ModalDelete'
import { Botao } from '../../components/Botao'

import Edit from '../../assets/edit.svg'
import Checked from '../../assets/checked.svg'
import Unchecked from '../../assets/unchecked.svg'
import Trash from '../../assets/trash.svg'

import banner2 from '../../assets/banner1.png'
import banner1 from '../../assets/banner2.png'
import banner3 from '../../assets/banner4.png'
import banner4 from '../../assets/banner3.png'

import {
 Container,
 Title,
 Content,
 Table,
 FilterContainer,
 FilterContainerSelect
} from './styles'

export function HomeBanners() {
 const title = 'Página Inicial'
 const subtitle = 'Banners'

 const fields = useMemo(
  () => [
   {
    id: 'Banner',
    imagem: String,
    type: String,
    title: String,
    text: String,
    btn_title: String,
    link: String,
    status: Number
   }
  ],
  []
 )

 const {
  banners,
  setBanners,
  orderBy,
  setOrderBy,
  modalAdd,
  toggleModalAdd,
  modalEdit,
  toggleModalEdit,
  modalDelete,
  toggleModalDelete,
  id,
  setID,
  offset,
  limit,
  handlePageClick
 } = useMain()

 const pageCount = Math.ceil(banners.length / limit)

 const handleOrderChange = event => {
  setOrderBy(event.target.value)
 }

 const loadBanners = useCallback(async () => {
  try {
   const response = await api.get(`banners?order=${orderBy}`)

   setBanners(response.data)
  } catch (error) {
   console.log('Ocorreu um erro ao buscar os banners')
  }
 }, [orderBy, setBanners])

 useEffect(() => {
  loadBanners()
 }, [loadBanners])

 return (
  <>
   <ToastContainer />

   {modalAdd && (
    <ModalAdd
     isClose={toggleModalAdd}
     isLoad={loadBanners}
     fields={fields}
     name="banners"
     title="Banner"
    />
   )}
   {modalDelete && (
    <ModalDelete
     isClose={toggleModalDelete}
     isLoad={loadBanners}
     id={id}
     name="banners"
     title="Banner"
    />
   )}
   {modalEdit && (
    <ModalEdit
     isClose={toggleModalEdit}
     isLoad={loadBanners}
     id={id}
     name="banners"
     folder="banners"
     title="Banner"
    />
   )}

   <Header title={title} subtitle={subtitle} />

   <Container>
    <FilterContainer>
     <Title>Gerenciador de banners</Title>
     <FilterContainerSelect
      name="filter"
      id="filter"
      onChange={handleOrderChange}
     >
      <option value="mais_recentes">Mais Recentes</option>
      <option value="mais_antigos">Mais Antigos</option>
      <option value="asc">Ordem alfabética (A a Z)</option>
      <option value="desc">Ordem alfabética reversa (Z a A)</option>
      <option value="update_desc">Atualizações mais recentes</option>
      <option value="update_asc">Atualizações mais antigas</option>
     </FilterContainerSelect>
    </FilterContainer>
    {banners.length <= 0 ? (
     <>Nenhum banner cadastrado.</>
    ) : (
     <>
      <Table>
       <thead>
        <tr>
         <th>Exibição</th>
         <th>Tipo de Banner</th>
         <th>Imagem</th>
         <th>Título</th>
         <th>Link</th>
         <th>Status</th>
         <th colSpan="2"></th>
        </tr>
       </thead>
       <tbody>
        {banners &&
         banners.slice(offset, offset + limit).map(banner => (
          <tr key={banner.id}>
           <td>{banner.id}</td>
           <td>{banner.type}</td>
           <td>
            <div>
             {banner.file ? (
              <img
               src={`${process.env.REACT_APP_IMAGE_URL}/uploads/banners/${banner.file}`}
               alt={banner.title}
              />
             ) : (
              ''
             )}
            </div>
           </td>
           <td>{banner.title}</td>
           <td>{banner.link}</td>
           <td>
            {banner.status === 1 ? (
             <img src={Checked} alt="Ativo" />
            ) : (
             <img src={Unchecked} alt="Inativo" />
            )}
           </td>
           <td onMouseDown={() => setID(banner.id)}>
            <img
             src={Edit}
             alt="Editar"
             title="Editar"
             onClick={toggleModalEdit}
            />
           </td>
           <td onMouseDown={() => setID(banner.id)}>
            <img
             src={Trash}
             alt="Deletar"
             title="Deletar"
             onClick={toggleModalDelete}
            />
           </td>
          </tr>
         ))}
       </tbody>
      </Table>

      <ReactPaginate
       previousLabel={'<'}
       nextLabel={'>'}
       pageCount={pageCount}
       onPageChange={handlePageClick}
       containerClassName={'pagination'}
       previousLinkClassName={'pagination__link'}
       nextLinkClassName={'pagination__link'}
       disabledClassName={'pagination__link--disabled'}
       activeClassName={'pagination__link--active'}
      />
     </>
    )}
   </Container>

   <Container>
    <Title>Especificações dos banners</Title>
    <Content>
     <div>
      <img src={banner1} alt="Banner foto + texto" />
      <h3>Banner foto + texto</h3>
      <p>Formato: 1106 x 650 pixels</p>
      <p>Tamanho: Máximo 1MB</p>
     </div>
     <div>
      <img src={banner2} alt="Banner cinema" />
      <h3>Banner Cinema</h3>
      <p>Formato: 1920 x 650 pixels</p>
      <p>Tamanho: Máximo 1MB</p>
     </div>
     <div>
      <img src={banner3} alt="Banner destaques" />
      <h3>Banner Destaques</h3>
      <p>Formato: 950 x 650 pixels</p>
      <p>Tamanho: Máximo 1MB</p>
     </div>
     <div>
      <img src={banner4} alt="Banner lojas" />
      <h3>Banner Lojas</h3>
      <p>Formato: 1920 x 320 pixels</p>
      <p>Tamanho: Máximo 1MB</p>
     </div>
     <div>
      <img src={banner3} alt="Mini banners" />
      <h3>Mini Banners</h3>
      <p>Formato: 468 x 320 pixels</p>
      <p>Tamanho: Máximo 1MB</p>
     </div>
    </Content>
   </Container>

   <Botao isOpen={toggleModalAdd} />
  </>
 )
}
